import { inject, ModuleWithProviders, NgModule } from '@angular/core';
import { RequiredValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/required.validation-message-resolver';
import { MinValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/min.validation-message-resolver';
import { MaxValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/max.validation-message-resolver';
import { MinLengthValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/min-length.validation-message-resolver';
import { MaxLengthValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/max-length.validation-message-resolver';
import { MinDatetimeValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/min-datetime.validation-message-resolver';
import { MaxDatetimeValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/max-datetime.validation-message-resolver';
import { IntegerValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/integer.validation-message-resolver';
import { applyValidationMessageResolvers } from './provider';
import { UrlValidationMessageResolver } from './resolvers/url.validation-message-resolver';
import { EmailValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/email-validation-message-resolver';
import { DivisibleByValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/divisible-by.validation-message-resolver';

import { SkMinLengthValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/sk-min-length.validation-message-resolver';
import { SkMinValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/sk-min.validation-message-resolver';
import { SkMaxLengthValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/sk-max-length.validation-message-resolver';
import { SkMaxValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/sk-max.validation-message-resolver';
import { SkIntegerValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/sk-integer.validation-message-resolver';
import { SkEmailValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/sk-email-validation-message-resolver';
import { SkUrlValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/sk-url.validation-message-resolver';
import { SkRequiredValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/sk-required.validation-message-resolver';
import { SkValidAliasValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/sk-valid-alias.validation-message-resolver';
import { SkNoLeadingDigitValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/resolvers/sk-no-leading-digit.validation-message-resolver';
import { applyValidationMessageResolvers as skApplyValidationMessageResolvers, DEFAULT_VALIDATION_MESSAGE } from '@ngx-strakit/validation';
import { TranslateService } from '@ngx-translate/core';
import { SkMaxDatetimeValidationMessageResolver } from './resolvers/sk-max-datetime.validation-message-resolver';
import { SkMinDatetimeValidationMessageResolver } from './resolvers/sk-min-datetime.validation-message-resolver';

@NgModule()
export class ValidationMessageResolverModule {
  static forModule(): ModuleWithProviders<ValidationMessageResolverModule> {
    return {
      ngModule: ValidationMessageResolverModule,
      providers: [
        {
          provide: DEFAULT_VALIDATION_MESSAGE,
          useFactory: () => {
            const translateService = inject(TranslateService);
            return translateService.instant('label.validation.default');
          },
        },
        ...applyValidationMessageResolvers(
          RequiredValidationMessageResolver,
          MinValidationMessageResolver,
          MaxValidationMessageResolver,
          MinLengthValidationMessageResolver,
          MaxLengthValidationMessageResolver,
          MinDatetimeValidationMessageResolver,
          MaxDatetimeValidationMessageResolver,
          MaxDatetimeValidationMessageResolver,
          IntegerValidationMessageResolver,
          UrlValidationMessageResolver,
          EmailValidationMessageResolver,
          DivisibleByValidationMessageResolver,
        ),
        ...skApplyValidationMessageResolvers(
          SkRequiredValidationMessageResolver,
          SkUrlValidationMessageResolver,
          SkMinLengthValidationMessageResolver,
          SkMinValidationMessageResolver,
          SkMaxLengthValidationMessageResolver,
          SkMaxValidationMessageResolver,
          SkIntegerValidationMessageResolver,
          SkEmailValidationMessageResolver,
          SkValidAliasValidationMessageResolver,
          SkNoLeadingDigitValidationMessageResolver,
          SkMaxDatetimeValidationMessageResolver,
          SkMinDatetimeValidationMessageResolver,
        ),
      ],
    };
  }
}
